export default [
  //佣金管理
  {
    path: '/gongju',
    component: () => import('@/views/gongju/index'),
    redirect: '/gongju/wuliu',
    children: [{
        path: '/gongju/wuliu',
        component: () => import('@/views/gongju/wuliu'),
        mete: {
          title: "物流",
        },
      },
      {
        path: '/gongju/net',
        component: () => import('@/views/gongju/net'),
        mete: {
          title: "在网及余额查询",
        },
      },
      {
        path: '/gongju/haomachongzhi',
        component: () => import('@/views/gongju/haomachongzhi'),
        mete: {
          title: "号码充值",
        },
      },
      {
        path: '/gongju/quanyichongzhi',
        component: () => import('@/views/gongju/quanyichongzhi'),
        mete: {
          title: "权益充值",
        },
      },
      {
        path: '/gongju/quanyichongzhiliebiao',
        component: () => import('@/views/gongju/quanyichongzhiliebiao'),
        mete: {
          title: "权益充值导入记录",
        },
      },
      {
        path: '/gongju/dingdan',
        component: () => import('@/views/gongju/dingdan'),
        mete: {
          title: "订单重复查询",
        },
      },
      {
        path: '/gongju/shanghao',
        component: () => import('@/views/gongju/shanghao/shanghao'),
        mete: {
          title: "号池",
        },
      },
      {
        path: '/gongju/shanghao/haoma',
        component: () => import('@/views/gongju/shanghao/haoma'),
        mete: {
          title: "号码",
        },
      },
      {
        path: '/gongju/shanghaolianjie',
        component: () => import('@/views/gongju/shanghaolianjie/shanghaolianjie'),
        mete: {
          title: "上号链接",
        },
      },
      {
        path: '/gongju/shaixuandingdan',
        component: () => import('@/views/gongju/shaixuandingdan/index'),
        mete: {
          title: "筛选订单",
        },
      },
      {
        path: '/gongju/erci',
        component: () => import('@/views/gongju/erci/erci'),
        mete: {
          title: "二次引导",
        },
      },
      {
        path: '/gongju/heilongjiang',
        component: () => import('@/views/gongju/heilongjiang/index'),
        mete: {
          title: "黑龙江",
        },
      },


      {
        path: '/gongju/yundan',
        component: () => import('@/views/gongju/yundan/index'),
        redirect: '/gongju/yundan/huichuanshangpin',
        children: [
          {
            path: '/gongju/yundan/huichuanshangpin',
            component: () => import('@/views/gongju/yundan/huichuanshangpin'),
            mete: {
              title: "回传商品",
            },
          },
          {
            path: '/gongju/yundan/huichuanjilu',
            component: () => import('@/views/gongju/yundan/huichuanjilu'),
            mete: {
              title: "回传记录",
            },
          }
        ]
      },

      {
        path: '/gongju/ziyouqudao',
        component: () => import('@/views/gongju/ziyouqudao/index'),
        redirect: '/gongju/ziyouqudao/ziyouqudao',
        children: [
          {
            path: '/gongju/ziyouqudao/ziyouqudao',
            component: () => import('@/views/gongju/ziyouqudao/ziyouqudao'),
            mete: {
              title: "自有渠道订单导入",
            },
          }
        ]
      },
      {
        path: '/gongju/ziyouqudao2',
        component: () => import('@/views/gongju/ziyouqudao2/index'),
        redirect: '/gongju/ziyouqudao2/ziyouqudao2',
        children: [
          {
            path: '/gongju/ziyouqudao2/ziyouqudao2',
            component: () => import('@/views/gongju/ziyouqudao2/ziyouqudao2'),
            mete: {
              title: "京东随销订单",
            },
          }
        ]
      },
      {
        path: '/gongju/tianmaopeifu',
        component: () => import('@/views/gongju/tianmaopeifu/index'),
        redirect: '/gongju/tianmaopeifu/tianmaopeifu',
        children: [
          {
            path: '/gongju/tianmaopeifu/tianmaopeifu',
            component: () => import('@/views/gongju/tianmaopeifu/tianmaopeifu'),
            mete: {
              title: "天猫赔付",
            },
          },
          {
            path: '/gongju/tianmaopeifu/tianmaopeifushangpin',
            component: () => import('@/views/gongju/tianmaopeifu/tianmaopeifushangpin'),
            mete: {
              title: "天猫赔付商品",
            },
          }
        ]
      },

      {
        path: '/gongju/tupianshengcheng',
        component: () => import('@/views/gongju/tupianshengcheng/index'),
        redirect: '/gongju/tupianshengcheng/zhutu',
        children: [
          {
            path: '/gongju/tupianshengcheng/zhutu',
            component: () => import('@/views/gongju/tupianshengcheng/zhutu'),
            mete: {
              title: "主图列表",
            },
          },
          {
            path: '/gongju/tupianshengcheng/xiangqingtu',
            component: () => import('@/views/gongju/tupianshengcheng/xiangqingtu'),
            mete: {
              title: "详情图列表",
            },
          },
          {
            path: '/gongju/tupianshengcheng/shengchengzhutu',
            component: () => import('@/views/gongju/tupianshengcheng/shengchengzhutu'),
            mete: {
              title: "生成主图",
            },
          },
          {
            path: '/gongju/tupianshengcheng/shengchengxiangqingtu',
            component: () => import('@/views/gongju/tupianshengcheng/shengchengxiangqingtu'),
            mete: {
              title: "生成详情图",
            },
          }
        ]
      },

      {
        path: '/gongju/haoma',
        component: () => import('@/views/gongju/haoma/index'),
        redirect: '/gongju/haoma/banlichanpin',
        children: [
          {
            path: '/gongju/haoma/banlichanpin',
            component: () => import('@/views/gongju/haoma/banlichanpin'),
            mete: {
              title: "办理产品",
            },
          },
          {
            path: '/gongju/haoma/banlijilu',
            component: () => import('@/views/gongju/haoma/banlijilu'),
            mete: {
              title: "办理记录",
            },
          }
        ]
      },


    ]
  },
  {
  	path: '/gongju/order_export_haoma',
  	name: 'order_export_haoma',
  	component: () => import('@/components/productionManagement/order_export_haoma')
  },
  {
  	path: '/gongju/order_export_haoma_daoru',
  	name: 'order_export_haoma_daoru',
  	component: () => import('@/components/productionManagement/order_export_haoma_daoru')
  }
]



// WEBPACK FOOTER //
// ./src/router/gongju.js